(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-discount-popup"] && !Shopify.designMode) return;
  try {
    
  (()=>{const p=document.querySelector('[data-welcome-popup]');if(!p||typeof p.showModal!=='function')return;const seen='belle_welcome20_seen',applied='belle_welcome20_applied',days=Number(p.dataset.frequency||14),recent=Date.now()-Number(localStorage.getItem(seen)||0)<days*86400000,close=()=>{localStorage.setItem(seen,String(Date.now()));p.close()};p.querySelectorAll('[data-popup-close]').forEach(b=>b.addEventListener('click',close));p.addEventListener('click',e=>{if(e.target===p)close()});p.addEventListener('cancel',()=>localStorage.setItem(seen,String(Date.now())));p.querySelector('[data-popup-yes]')?.addEventListener('click',()=>{p.querySelector('[data-popup-offer]').hidden=true;p.querySelector('[data-popup-signup]').hidden=false;p.querySelector('input[type=email]')?.focus()});p.querySelector('[data-copy-code]')?.addEventListener('click',async e=>{await navigator.clipboard.writeText('WELCOME20');e.currentTarget.textContent=p.dataset.copied});if(p.querySelector('[data-form-success]')){p.querySelector('[data-popup-offer]').hidden=true;p.querySelector('[data-popup-signup]').hidden=true;p.querySelector('[data-popup-success]').hidden=false;localStorage.setItem(seen,String(Date.now()));localStorage.setItem(applied,'true');p.showModal();setTimeout(()=>location.replace('/discount/WELCOME20?redirect='+encodeURIComponent(location.pathname)),1800);return}if(!recent&&localStorage.getItem(applied)!=='true')setTimeout(()=>p.showModal(),Number(p.dataset.delay||3000))})();

  } catch(e) { console.error(e); }
})();
})();
